export default "__VITE_ASSET__8zXbnHkJ__"